import request from '@/infra/request';

// 获取自定义类别
export function quoteCategoryList(params) {
    return request.get('/api/T_Quote_Selected/CategoryList', { params });
}

// 获取自定义行情
export function quoteContractList(params) {
    return request.get('/api/T_Quote_Selected/ContractList', { params });
}

// 增加自定义类别
export function quoteAddCategory(data) {
    return request.post('/api/T_Quote_Selected/AddCategory', data);
}

// 增加自定义行情
export function quoteAddContract(data) {
    return request.post('/api/T_Quote_Selected/AddContract', data);
}

// 删除自定义类别
export function quoteDeleteCategory(data) {
    return request.post('/api/T_Quote_Selected/DeleteCategory', data);
}

// 删除自定义行情
export function quoteDeleteContract(data) {
    return request.post('/api/T_Quote_Selected/DeleteContract', data);
}

// 当日行情合约列表
export function getTodayQuoteList() {
    return request.post('/api/T_Quote_Selected/QuoteList');
}

// 一般委托
export function orderAdd(data) {
    return request.post('/api/T_InstrumentOrder/OrderAdd', data);
}

// 委托(条件单)
export function conditionalOrderAdd(data) {
    return request.post('/api/T_InstrumentOrder/ConditionalOrderAdd', data);
}

export function commodityTrade(data) {
    return request.post('/api/T_Backtesting/CommodityTrade', data);
}

export function instrumentParameter(data) {
    return request.post('/api/T_Backtesting/InstrumentParameters', data);
}

export function startCalculate(data) {
    return request.post('/api/T_Backtesting/StartCalculate', data);
}

export function queryBacktestingRport(params) {
    return request.get('/api/T_Backtesting/QueryBacktestingRport', { params });

}

export function settlementList(params) {
    return request.get('/api/T_Settlement/list', { params });
}

export function settlementCalendar(params) {
    return request.get('/api/T_Settlement/Query_SettlmentCalendar', { params });
}

export function settlementAciton(data) {
    return request.post('/api/T_Settlement/Settlement', data);
}

export function settlementHisAciton(data) {
    return request.post('/api/T_Settlement/HisSettlementInput', data);
}

export function settlementHisContract(data) {
    return request.post('/api/T_Settlement/HisContractInitial', data);
}

export function instrumentTradeReport(params) {
    return request.get('/api/T_Settlement/Query_InstrumentTradeReport', { params });
}

export function hedgingTaskReport(params) {
    return request.get('/api/T_Settlement/Query_HedgingTaskReport', { params });
}

export function settlementPrice(params) {
    return request.get('/api/T_Settlement_Price/list', { params });
}

export function settlementLog(params) {
    return request.get('/api/T_Settlement_Log/list', { params });
}
